import SiteAssignmentsDto from "../components/Common/dtos/SiteAssignmentsDto";
import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useUser } from "../components/UserAccess/useUser";

const useGetTransportSiteAssignment = (transportId?: string, options?: QueryOptions<SiteAssignmentsDto>) => {
  const user = useUser();

  return useUserQuery<SiteAssignmentsDto>(
    { path: `/api/businesses/${user.selectedBusiness?.id!}/transports/${transportId}/siteAssignment` },
    options);
}

export default useGetTransportSiteAssignment;
